import React from 'react';

import { Typography } from 'lighthouse';

import { MenuItemProps } from './models';

export const MenuItem = ({ item, isDark, active = false, badgeContent }: MenuItemProps) => {
    const inactiveColor = isDark ? 'text-neutral-400' : 'text-neutral-500';
    const activeColor = isDark ? 'text-white' : 'text-primary';

    return (
        <div className='relative flex flex-col items-center justify-center gap-0.5'>
            <span
                className={`relative flex h-6 w-6 items-center justify-center transition-colors duration-200 ease-out motion-reduce:transition-none
                    ${active ? activeColor : inactiveColor}`}>
                {item.icon}
                {!!badgeContent && (
                    <span
                        className='absolute -right-1.5 -top-1 flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-primary px-0.5
                            text-[9px] font-bold leading-none text-white'>
                        {badgeContent}
                    </span>
                )}
            </span>
            <Typography
                variant='caption'
                className={`text-[10px] leading-3 transition-colors duration-200 ease-out motion-reduce:transition-none ${
                    active ? `font-bold ${activeColor}` : `font-medium ${inactiveColor}`
                }`}>
                {item.title}
            </Typography>
        </div>
    );
};
